module.exports = __webpack_public_path__ + "assets/img/llh_c2.d695f2a9.jpg";